// import React from "react";
// import { useState } from "react";

// // Chakra imports
// import {
//   Flex,
//   Icon,
//   Image,
//   Text,
//   useColorModeValue,
//   Link,
//   Button,
//   IconButton,
//   Tooltip,
//   useClipboard, Step,
//   StepDescription,
//   StepIcon,
//   StepIndicator,
//   StepNumber,
//   StepSeparator,
//   StepStatus,
//   StepTitle,
//   Stepper,
//   useSteps,
// } from "@chakra-ui/react";
// // Custom components
// import Card from "components/card/Card.js";
// // Assets
// import { StarIcon, TriangleUpIcon } from "@chakra-ui/icons";
// import Amazon from 'assets/img/amazon.ico';
// import Flipkart from 'assets/img/flipkart.ico';
// import Snapdeal from 'assets/img/snapdeal.ico';
// import Meesho from 'assets/img/meesho.ico';
// import Glowroad from 'assets/img/glowroad.ico';
// import Shopsy from 'assets/img/shopsy.ico';
// import freeup from 'assets/img/freeup.ico';


// import { MdCheckCircle, MdCancel, MdOutlineError, MdCommentsDisabled, MdShoppingCart, MdContentCopy, MdAlbum } from "react-icons/md";




// export default function Item(props) {
//   const { product, handleUpdateProduct, removeFromUpdate, handleInsertSeller, removeFromInsert, index, handleInsertAbuse,isAdmin } = props;
//   // Chakra Color Mode
//   const textColor = useColorModeValue("brands.900", "white");
//   const bgItem = useColorModeValue(
//     { bg: "white", boxShadow: "0px 40px 58px -20px rgba(112, 144, 176, 0.12)" },
//     { bg: "navy.700", boxShadow: "unset" }
//   );
//   const textColorDate = useColorModeValue("secondaryGray.600", "white");
//   const { hasCopied, onCopy } = useClipboard(product.prod_code);
//   // const [toggleReport, setToggleReport] = useState(false);
//   const [toggleTest, setToggleTest] = useState(false);
//   const [toggleGenuine, setToggleGenuine] = useState(false);
//   const [toggleOrderPlaced, setToggleOrderPlaced] = useState(false);
//   const [toggleNotReceived, setToggleNotReceived] = useState(false);
//   const [toggleCounterfeit, setToggleCounterfeit] = useState(false);


//   const handleToggleGenuine = async (product) => {
//     setToggleGenuine(!toggleGenuine);
//     setToggleNotReceived(false);
//     setToggleOrderPlaced(false);
//     setToggleCounterfeit(false);
//     if (!toggleGenuine) {
//       await handleUpdateProduct(product, 3);
//       await handleInsertSeller(product, 'TW');
//       await handleInsertAbuse(product, '0')

//     } else {
//       await removeFromUpdate(product, 3);
//       await removeFromInsert(product, 'TW');
//       await handleInsertAbuse(product, '0')

//     }
//   }
//   const handleNotReceived = async (product) => {
//     setToggleGenuine(false);
//     setToggleNotReceived(!toggleNotReceived);
//     setToggleOrderPlaced(false);
//     setToggleCounterfeit(false);
//     if (!toggleNotReceived) {
//       await handleUpdateProduct(product, 2);
//       // await handleInsertSeller(product, 'TC');

//     } else {
//       await removeFromUpdate(product, 2);
//       // await removeFromInsert(product, 'TC');
//     }
//   }
//   // const handleToggleTest = async (keyword_id, platform_id, seller_name) => {
//   //   setToggleWhiteList(false);
//   //   setToggleTest(!toggleTest);
//   //   setToggleBlackList(false);
//   //   if (!toggleTest) {
//   //     await handleInsertSeller(keyword_id, platform_id, seller_name, 'T');
//   //   } else {
//   //     await removeFromInsert(keyword_id, platform_id, seller_name, 'T');
//   //   }
//   // }

//   const handleToggleOrderPlaced = async (psm_id) => {
//     setToggleOrderPlaced(!toggleOrderPlaced);
//     if (!toggleOrderPlaced) {
//       await handleUpdateProduct(product, 1);
//     } else {
//       await removeFromUpdate(product, 1);
//     }
//   }
//   const handleToggleCounterfeit = async (product) => {
//     setToggleGenuine(false);
//     setToggleNotReceived(false);
//     setToggleOrderPlaced(false);
//     setToggleCounterfeit(!toggleCounterfeit);
//     if (!toggleCounterfeit) {
//       await handleInsertSeller(product, 'TC');
//       await handleUpdateProduct(product, 4);
//       await handleInsertAbuse(product, 6);


//     } else {
//       await removeFromInsert(product, 'TC');
//       await removeFromUpdate(product, 4);
//     }
//   }


//   const getPlatformIcon = (platformId) => {
//     switch (platformId) {
//       case 1:
//         return Amazon; // Use imported Amazon icon
//       case 2:
//         return Flipkart; // Use imported Flipkart icon
//       case 3:
//         return Snapdeal;
//       case 4:
//         return Meesho;// Use imported Snapdeal icon
//       case 5:
//         return Glowroad;
//       case 6:
//         return Shopsy;
//       case 7:
//         return freeup;
//       default:
//         return null;
//     }
//   };
//   const renderStars = (rating) => {
//     rating = rating < 0 ? 0 : rating
//     const filledStars = Math.floor(rating);
//     const hasHalfStar = rating % 1 >= 0.5;
//     const totalStars = filledStars + (hasHalfStar ? 1 : 0);
//     const stars = [];

//     for (let i = 0; i < filledStars; i++) {
//       stars.push(<Icon as={StarIcon} color="gold" key={`star-${i}`} />);
//     }

//     if (hasHalfStar) {
//       stars.push(<Icon as={StarIcon} color="gold" key={`half-star`} />);
//     }

//     const emptyStars = 5 - totalStars;
//     for (let i = 0; i < emptyStars; i++) {
//       stars.push(<Icon as={StarIcon} color="gray.300" key={`empty-star-${i}`} />);
//     }

//     return stars;
//   };
//   return (
//     <Card
//       _hover={bgItem}
//       bg='transparent'
//       boxShadow='unset'
//       px='24px'
//       py='21px'
//       transition='0.2s linear'>
//       <Flex direction={{ base: "column" }} justify='center'>
//         <Flex position='relative' align='center'>
//           <Link href={product.image_link} isExternal me='15px'>
//             <Image src={product.image_link} w='80px' me='16px' />
//           </Link>
//           <Flex
//             direction='column'
//             w={{ base: "70%", md: "100%" }}
//             me={{ base: "4px", md: "32px", xl: "10px", "3xl": "32px" }}>

//             <Text
//               color={textColor}
//               fontSize={{
//                 base: "md",
//               }}
//               mb='5px'
//               fontWeight='bold'
//               me='14px'
//             >
//               {index + 1}.&nbsp;&nbsp;
//               <Link href={product.prod_link} textDecoration='underline' isExternal>
//                 {product.title}
//               </Link>
//             </Text>
//             <Flex direction='row'>
//               <Text
//                 color='secondaryGray.600'
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='400'
//                 me='14px'>
//                 {product.keyword}
//                 <Image src={getPlatformIcon(product.platform_id)} width="15px" />

//               </Text>
//             </Flex>
//             <Flex direction='row'>
//               <Text
//                 color='secondaryGray.600'
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='400'
//                 me='14px'>
//                 Store Name:
//               </Text>
//               <Text
//                 color={textColor}
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 mb='5px'
//                 fontWeight='bold'
//                 me='14px'
//               >
//                 {product.store_name}
//               </Text>
//             </Flex>
//             <Flex direction='row'>
//               <Text
//                 color='secondaryGray.600'
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='400'
//                 me='14px'>
//                 Product Code
//               </Text>
//               <Text
//                 color={textColor}
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='bold'
//               >
//                 {product.prod_code}
//               </Text>
//               <Tooltip label={hasCopied ? "Copied!" : "Copy to Clipboard"}>
//                 <IconButton
//                   aria-label="Copy to Clipboard"
//                   icon={<MdContentCopy />}
//                   onClick={onCopy}
//                   variant="ghost"
//                   colorScheme={hasCopied ? "green" : "gray"}
//                   height='17px'
//                 />
//               </Tooltip>

//             </Flex>
//             <Flex direction='row' hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>
//               <Text
//                 color='secondaryGray.600'
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='400'
//                 me='14px'>
//                 Seller Name:
//               </Text>
//               <Text
//                 color={textColor}
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 mb='5px'
//                 fontWeight='bold'
//                 me='14px'
//               >
//                 {product.seller_name}
//               </Text>
//             </Flex>
//             <Flex direction='row'  hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>
//               <Text
//                 color='secondaryGray.600'
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='400'
//                 me='14px'>
//                 MRP :
//               </Text>
//               <Text
//                 color={textColor}
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 mb='5px'
//                 fontWeight='bold'
//                 me='14px'
//               >
//                 Rs. {product.mrp}
//               </Text>
//             </Flex>
//             <Flex direction='row'  hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>
//               <Text
//                 color='secondaryGray.600'
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='400'
//                 me='14px'>
//                 Selling Price:
//               </Text>
//               <Text
//                 color={textColor}
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='semibold'
//                 mb='5px'
//                 me='14px'
//               >
//                 Rs. {product.selling_price}
//               </Text>
//             </Flex>
//             <Flex direction='row'  hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>
//               <Text
//                 color='secondaryGray.600'
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='400'
//                 me='14px'>
//                 Manufacturer:
//               </Text>
//               <Text
//                 color={textColor}
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 mb='5px'
//                 fontWeight='bold'
//                 me='14px'
//               >
//                 {product.manufacturer}
//               </Text>
//             </Flex>

//             <Flex direction='row'  hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>
//               {renderStars(product.overall_rating)}
//               <Text
//                 color='secondaryGray.600'
//                 fontSize={{
//                   base: "sm",
//                 }}
//                 fontWeight='400'
//                 me='14px'>
//                 &nbsp;&nbsp;{product.no_of_rating}
//               </Text>
//             </Flex>
//           </Flex>

//           {isAdmin && (

//           <Flex
//             me={{ base: "4px", md: "32px", xl: "10px", "3xl": "32px" }}
//             align='center' direction="column">
//             {product.test_purchase_status === null &&
//               <Tooltip label='Order Placed'>
//                 <Button colorScheme='gray' fontSize="20px" p='0px' onClick={() => handleToggleOrderPlaced(product.psm_id, product.test_purchase_status)}>
//                   <Icon color={toggleOrderPlaced === true || product.test_purchase_status > 0 ? 'green' : 'gray'} as={MdAlbum} />
//                 </Button>
//               </Tooltip>
//             }
//             {/* <Tooltip label='Report seller'>
//               <Button colorScheme="gray" fontSize="20px" p='0px'
//                 onClick={() => handleToggleReport(product.keyword_id, product.platform_id, product.seller_name)}>
//                 <Icon color={toggleReport === true ? 'gold' : 'gray'} as={MdOutlineError} />
//               </Button>
//             </Tooltip> */}
//             {product.test_purchase_status !== null &&
//               <>
//                 <Tooltip label='Order Not Received'>
//                   <Button colorScheme="gray" fontSize="20px" p='0px'
//                     onClick={() => handleNotReceived(product)}>
//                     <Icon color={toggleNotReceived === true ? 'yellow' : 'gray'} as={MdOutlineError} />
//                   </Button>
//                 </Tooltip>
//                 <Tooltip label='Genuine Product'>
//                   <Button colorScheme="gray" fontSize="20px" p='0px'
//                     onClick={() => handleToggleGenuine(product)}>
//                     <Icon color={toggleGenuine === true ? 'green' : 'gray'} as={MdCheckCircle} />
//                   </Button>
//                 </Tooltip>
//                 <Tooltip label='Counterfeit product'>
//                   <Button colorScheme="gray" fontSize="20px" p='0px' onClick={() => handleToggleCounterfeit(product)}>
//                     <Icon color={toggleCounterfeit === true ? 'red' : 'gray'} as={MdCancel} />
//                   </Button>
//                 </Tooltip>
//               </>
//             }
//           </Flex>
//           )}

//         </Flex>

//       </Flex>
//     </Card>
//   );
// }









import React, { useState } from "react";
import {
  Flex, Icon, Image, Text, Link, Button, IconButton,
  Tooltip, useClipboard, Box, Checkbox, Badge,
  HStack, VStack, useColorModeValue
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import { StarIcon } from "@chakra-ui/icons";
import { MdCheckCircle, MdCancel, MdOutlineError, MdShoppingCart, MdContentCopy, MdAlbum } from "react-icons/md";
import Amazon from 'assets/img/amazon.ico';
import Flipkart from 'assets/img/flipkart.ico';
import Snapdeal from 'assets/img/snapdeal.ico';
import Meesho from 'assets/img/meesho.ico';
import Glowroad from 'assets/img/glowroad.ico';
import Shopsy from 'assets/img/shopsy.ico';
import freeup from 'assets/img/freeup.ico';

// --- Configuration ---
const getStatusConfig = (val) => {
  const configs = {
    genuine: { color: "green", label: "GENUINE", icon: MdCheckCircle },
    counterfeit: { color: "red", label: "COUNTERFEIT", icon: MdCancel },
    notReceived: { color: "orange", label: "NOT RECEIVED", icon: MdOutlineError },
    orderPlaced: { color: "blue", label: "ORDER PLACED", icon: MdShoppingCart },
  };
  return configs[val] || { color: "gray", label: "" };
};

// --- Action Buttons ---
const ActionButtons = ({ product, handlers, toggles, layout }) => {
  const isGrid = layout === 'grid';

  // Case 1: Order Not Yet Placed
  if (product.test_purchase_status === null) {
    return (
      <Tooltip label='Mark Order Placed'>
        <Button
          size="sm"
          width={isGrid ? "100%" : "auto"}
          colorScheme={toggles.orderPlaced ? "blue" : "gray"}
          leftIcon={<Icon as={MdShoppingCart} />}
          onClick={() => handlers.handleToggleOrderPlaced(product)}
        >
          Order Placed
        </Button>
      </Tooltip>
    );
  }

  // Case 2: Order Placed (Show 3 Options)
  return (
    <Flex gap={2} justify={isGrid ? "center" : "flex-end"}>
      {/* 1. Not Received */}
      <Tooltip label='Order Not Received'>
        <IconButton
          size="sm"
          colorScheme={toggles.notReceived ? "orange" : "gray"}
          icon={<Icon as={MdOutlineError} />}
          onClick={() => handlers.handleNotReceived(product)}
          aria-label="Not Received"
        />
      </Tooltip>

      {/* 2. Genuine */}
      <Tooltip label='Genuine Product'>
        <IconButton
          size="sm"
          colorScheme={toggles.genuine ? "green" : "gray"}
          icon={<Icon as={MdCheckCircle} />}
          onClick={() => handlers.handleToggleGenuine(product)}
          aria-label="Genuine"
        />
      </Tooltip>

      {/* 3. Counterfeit */}
      <Tooltip label='Counterfeit Product'>
        <IconButton
          size="sm"
          colorScheme={toggles.counterfeit ? "red" : "gray"}
          icon={<Icon as={MdCancel} />}
          onClick={() => handlers.handleToggleCounterfeit(product)}
          aria-label="Counterfeit"
        />
      </Tooltip>
    </Flex>
  );
};

// --- Overlay (Grid View Only) ---
const StatusOverlay = ({ toggles }) => {
  const activeKey = Object.keys(toggles).find(k => toggles[k] === true);
  if (!activeKey) return null;

  const config = getStatusConfig(activeKey);

  return (
    <Box
      position="absolute"
      top="0" left="0" right="0" bottom="0"
      bg="blackAlpha.700"
      borderRadius="xl"
      zIndex="2"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Icon as={config.icon} color={`${config.color}.400`} w={10} h={10} mb={2} />
      <Text color="white" fontWeight="bold" fontSize="xs" letterSpacing="wider">
        {config.label}
      </Text>
    </Box>
  );
};

// --- Grid View Component ---
const GridView = ({ product, index, isAdmin, handlers, toggles, common }) => {
  const { textColor, getPlatformIcon, renderStars, onCopy } = common;

  // Active State styling
  const activeKey = Object.keys(toggles).find(k => toggles[k] === true);
  const statusInfo = getStatusConfig(activeKey);
  const borderColor = activeKey ? `${statusInfo.color}.400` : "transparent";

  return (
    <Card
      p='5px'
      bg="white" _dark={{ bg: "navy.800" }}
      transition='0.2s linear'
      _hover={{ shadow: "lg", transform: "translateY(-4px)" }}
      border={activeKey ? "2px solid" : "1px solid"}
      borderColor={activeKey ? borderColor : "transparent"}
      h="100%"
    >
      <Box position='relative' bg='white' p='15px' h='200px' borderBottom="1px solid" borderColor="gray.100"overflow="hidden" borderRadius="xl">

        <StatusOverlay toggles={toggles} />
        <Link href={product.image_link} isExternal w='100%' h='100%' display="block" overflow="hidden"  >

          <Image src={product.image_link} w='100%' h='100%' objectFit='contain'  />
        </Link>

        <Box position='absolute' top='10px' left='10px' bg="white" borderRadius="md" p="1" shadow="sm">
          <Image src={getPlatformIcon(product.platform_id)} w='16px' />
        </Box>
      </Box>

      <VStack px='15px' align='start' spacing='8px' flex='1' py={2}>
        <Link href={product.prod_link} isExternal w="100%">
          <Text color={textColor} fontWeight='700' fontSize='sm' noOfLines={2} h="40px">
            {index + 1}. {product.title}
          </Text>
        </Link>

        <Flex width="100%" justify="space-between" align="center">
          <Text color={textColor} fontWeight='bold'>Rs. {product.selling_price}</Text>
          <HStack spacing="1px">{renderStars(product.overall_rating)}</HStack>
        </Flex>

        {/* Info Box */}
        <VStack w='100%' align="start" spacing={1} bg="gray.50" _dark={{ bg: "whiteAlpha.100" }} p="2" borderRadius="md">
          <Text fontSize='13px' color="gray.500" noOfLines={1} hidden={!product.seller_name}>
            Seller: <b>{product.seller_name}</b>
          </Text>
          <Text fontSize='13px' color="gray.500" noOfLines={1} hidden={!product.store_name}>
            Store: {product.store_name}
          </Text>
          <HStack w="100%" justify="space-between" pt={1}>
            <Text fontSize='13px' color="gray.500">Code: <b>{product.prod_code}</b></Text>
            <IconButton size='xs' icon={<MdContentCopy />} variant='ghost' h="20px" onClick={onCopy} />
          </HStack>
        </VStack>
      </VStack>

      {isAdmin && (
        <Box p={2} borderTop="1px solid" borderColor="gray.100">
          <ActionButtons product={product} handlers={handlers} toggles={toggles} layout="grid" />
        </Box>
      )}
    </Card>
  );
};

// --- List View Component ---
const ListView = ({ product, index, isAdmin, handlers, toggles, common }) => {
  const { textColor, getPlatformIcon, renderStars, onCopy } = common;

  // Active State styling
  const activeKey = Object.keys(toggles).find(k => toggles[k] === true);
  const statusInfo = getStatusConfig(activeKey);

  const borderColor = activeKey ? `${statusInfo.color}.400` : "transparent";
  const bgStyle = activeKey
    ? { bg: `${statusInfo.color}.50`, _dark: { bg: `rgba(0,0,0,0.2)` } }
    : { bg: "white", _dark: { bg: "navy.800" } };

  return (
    <Card
      p="16px"
      mb="10px"
      position="relative"
      overflow="hidden"
      borderLeftWidth={activeKey ? "5px" : "0px"}
      borderLeftColor={borderColor}
      bg={bgStyle.bg}
      _dark={bgStyle._dark}
      transition="all 0.2s"
      boxShadow="sm"
      _hover={{ boxShadow: "md" }}
    >
      <Flex align="center" justify={"space-between"} gap={4}>
        <Flex gap={2} >
          {/* Image */}

          <Box position="relative" w="100px" h="100px" flexShrink={0} m={2}>
            <Link href={product.prod_link} isExternal w='100%' h='100%' display="block">
              <Image src={product.image_link} w="100%" h="100%" objectFit="contain" />
            </Link>
            <Box position='absolute' bottom='0' left='0' bg="white" _dark={{ bg: "navy.900" }} borderRadius="tr-md" p="1" shadow="sm">
              <Image src={getPlatformIcon(product.platform_id)} w='16px' />
            </Box>
          </Box>

          {/* Content */}
          <Box >
            <Flex mb={1} wrap="wrap">
              <Text fontWeight="bold" fontSize="md" color={textColor} mr={2}>
                {index + 1}. <Link href={product.prod_link} isExternal>{product.title}</Link>
              </Text>
              {activeKey && (
                <Badge colorScheme={statusInfo.color} variant="solid">
                  {statusInfo.label}
                </Badge>
              )}
            </Flex>

            <Flex gap={4} mb={2} fontSize="xs" color="gray.500" align="center">
              <Text>{product.keyword}</Text>
              {renderStars(product.overall_rating)}
            </Flex>

            <Flex gap={4} align="center" fontSize="sm" wrap="wrap" mb={2}>
              <Text fontWeight="bold" color={textColor}>Rs. {product.selling_price}</Text>
              <HStack>
                <Text color="gray.500">Code: {product.prod_code}</Text>
                <IconButton size='xs' icon={<MdContentCopy />} onClick={onCopy} variant='ghost' />
              </HStack>
              <Text color="gray.500" hidden={!product.seller_name}>
                Seller: <Text as="span" fontWeight="semibold" color={textColor}>{product.seller_name}</Text>
              </Text>
            </Flex>
          </Box>
        </Flex>

        <Box>

          {/* Actions */}
          {isAdmin && (
            <ActionButtons product={product} handlers={handlers} toggles={toggles} layout="list" />
          )}
        </Box>
      </Flex>
    </Card>
  );
};

// --- Main Item Component ---
export default function Item(props) {
  const { product, handleUpdateProduct, removeFromUpdate, handleInsertSeller, removeFromInsert, index, handleInsertAbuse, isAdmin, viewMode = "list" } = props;

  const textColor = useColorModeValue("brands.900", "white");
  const { hasCopied, onCopy } = useClipboard(product.prod_code);

  // Local State
  const [toggleGenuine, setToggleGenuine] = useState(false);
  const [toggleOrderPlaced, setToggleOrderPlaced] = useState(false);
  const [toggleNotReceived, setToggleNotReceived] = useState(false);
  const [toggleCounterfeit, setToggleCounterfeit] = useState(false);

  // --- Handlers (Original Logic) ---
  const handleToggleGenuine = async (product) => {
    setToggleGenuine(!toggleGenuine);
    setToggleNotReceived(false);
    setToggleOrderPlaced(false);
    setToggleCounterfeit(false);
    if (!toggleGenuine) {
      await handleUpdateProduct(product, 3);
      await handleInsertSeller(product, 'TW');
      await handleInsertAbuse(product, '0')
    } else {
      await removeFromUpdate(product, 3);
      await removeFromInsert(product, 'TW');
      await handleInsertAbuse(product, '0')
    }
  }

  const handleNotReceived = async (product) => {
    setToggleGenuine(false);
    setToggleNotReceived(!toggleNotReceived);
    setToggleOrderPlaced(false);
    setToggleCounterfeit(false);
    if (!toggleNotReceived) {
      await handleUpdateProduct(product, 2);
    } else {
      await removeFromUpdate(product, 2);
    }
  }

  const handleToggleOrderPlaced = async () => {
    setToggleOrderPlaced(!toggleOrderPlaced);
    if (!toggleOrderPlaced) {
      await handleUpdateProduct(product, 1);
    } else {
      await removeFromUpdate(product, 1);
    }
  }

  const handleToggleCounterfeit = async (product) => {
    setToggleGenuine(false);
    setToggleNotReceived(false);
    setToggleOrderPlaced(false);
    setToggleCounterfeit(!toggleCounterfeit);
    if (!toggleCounterfeit) {
      await handleInsertSeller(product, 'TC');
      await handleUpdateProduct(product, 4);
      await handleInsertAbuse(product, 6);
    } else {
      await removeFromInsert(product, 'TC');
      await removeFromUpdate(product, 4);
    }
  }

  // Grouped for children
  const handlers = {
    handleToggleGenuine,
    handleNotReceived,
    handleToggleOrderPlaced,
    handleToggleCounterfeit
  };

  const toggles = {
    genuine: toggleGenuine,
    orderPlaced: toggleOrderPlaced,
    notReceived: toggleNotReceived,
    counterfeit: toggleCounterfeit
  };

  const common = {
    textColor,
    onCopy,
    hasCopied,
    getPlatformIcon: (id) => {
      switch (id) {
        case 1: return Amazon;
        case 2: return Flipkart;
        case 3: return Snapdeal;
        case 4: return Meesho;
        case 5: return Glowroad;
        case 6: return Shopsy;
        case 7: return freeup;
        default: return null;
      }
    },
    renderStars: (rating) => {
      rating = rating < 0 ? 0 : rating;
      const filledStars = Math.floor(rating);
      const hasHalfStar = rating % 1 >= 0.5;
      const stars = [];
      for (let i = 0; i < filledStars; i++) stars.push(<Icon as={StarIcon} color="gold" key={`s-${i}`} />);
      if (hasHalfStar) stars.push(<Icon as={StarIcon} color="gold" key={`hs`} />);
      const emptyStars = 5 - stars.length;
      for (let i = 0; i < emptyStars; i++) stars.push(<Icon as={StarIcon} color="gray.300" key={`e-${i}`} />);
      return stars;
    }
  };

  return viewMode === 'grid'
    ? <GridView {...props} handlers={handlers} toggles={toggles} common={common} />
    : <ListView {...props} handlers={handlers} toggles={toggles} common={common} />;
}